import { render, staticRenderFns } from "./petgiftbag.vue?vue&type=template&id=010fb224&scoped=true&"
import script from "./petgiftbag.vue?vue&type=script&lang=js&"
export * from "./petgiftbag.vue?vue&type=script&lang=js&"
import style0 from "./petgiftbag.vue?vue&type=style&index=0&id=010fb224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010fb224",
  null
  
)

export default component.exports